import { render, staticRenderFns } from "./login.vue?vue&type=template&id=d020cf96&scoped=true&"
import script from "./login.js?vue&type=script&lang=js&"
export * from "./login.js?vue&type=script&lang=js&"
import style0 from "./login.css?vue&type=style&index=0&id=d020cf96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d020cf96",
  null
  
)

export default component.exports